import React from 'react';
import { withRouter, Link } from 'react-router-dom';

import ContentLayout from 'component/page/content';
import { OfferPricing } from 'component/content/pricing';
import { HOBBY_TIER, STARTUP_TIER, SCALE_TIER, ENTERPRISE_TIER } from 'component/constant/pricing';
import {LoaderRipple} from 'component/loader';

import API, {handleError} from 'utils/xhr';
import { setPaymentTier, setOfferValidDate, hasStoredToken } from 'utils/authentication';


class Page extends React.Component {

  constructor(props){
    super(props);
    const {offer_partner_key} = props.match.params;
    this.state = {
      offer_partner_key: offer_partner_key || null,
    }
  }

  render (){
    if (hasStoredToken()){
      return (
        <ContentLayout id="offer-logged-in-page">
          <OfferLoggedInView offer_partner_key={this.state.offer_partner_key} />
        </ContentLayout>
      )
    }

    return (
      <ContentLayout id="offer-logged-out-page">
        <div className="flex-center my-5">
          <OfferLoggedOutView offer_partner_key={this.state.offer_partner_key} />
        </div>
      </ContentLayout>
    )
  }
}

class OfferLoggedOutView extends React.Component {

  constructor(props){
    super(props);
    const {offer_partner_key} = this.props;
    this.state = {
      offer_partner_key: offer_partner_key || null,
      partner_info: null,
    }
  }

  componentDidMount(){
    const url = '/payments/offer/' + this.state.offer_partner_key + '/info';
    API.get(url).then(response =>{
      const state = this.state;
      state.partner_info = response.data.data;
      this.setState(state);
    },(error) =>{
      handleError(error, this.props.history, window.location.pathname);
    })
  }

  render (){
    const partner_info = this.state.partner_info;
    
    if (partner_info === undefined || partner_info === null){
      return (<LoaderRipple fetching_data={true} />)
    }


    return (
      <div className="flex-center my-5">
        <div className="flex-center">
          <div className="offer-partner-details">
            <div className="">
              <img style={{height: "60px"}} className="hero mx-3" src="/static/images/cursor.svg" alt="Divshow product cursor" />
              <i className="fa fa-plus fa-2x mx-5"></i>
              <img src={partner_info.logo} alt="divshow offer partner"/>
            </div>
          </div>
        </div>
        <div className="flex-center my-5">
          <div className="m-3 content-section container">
            <div className="text-center">
              <span className="text-size-1 text-dark">Please <Link to={"/login?dest=" + window.location.pathname}>Login</Link> to view a customized view of this offer! </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class OfferLoggedInView extends React.Component {

  constructor(props){
    super(props);
    const {offer_partner_key} = this.props;
    this.state = {
      offer_partner_key: offer_partner_key || null,
      activating_offer: false,
      offer_xid: null,
    }
  }

  componentDidMount(){
    const url = '/payments/offer/' + this.state.offer_partner_key;
    API.get(url).then(response =>{
      const state = this.state;
      state.offer_details = response.data.data;
      this.setState(state);
    },(error) =>{
      handleError(error, this.props.history, window.location.pathname);
    })
  }

  activateOffer(e){
    e.preventDefault();

    const state = this.state;
    state.activating_offer = true;
    this.setState(state);

    const offer_id = e.currentTarget.dataset.key;

    const url = '/payments/offer/' + this.state.offer_partner_key;
    const data = {
      'offer_id': offer_id,
    }
    API.post(url, data).then(response =>{

      const offer = response.data.data;
      setPaymentTier(offer.offer_data.tier);
      setOfferValidDate(offer.offer_validity);

      const state = this.state;
      state.activating_offer = false;
      state.offer_xid = response.data.data.offer_xid
      this.setState(state);

      },(error) =>{
      handleError(error, this.props.history, window.location.pathname);
    })
  }

  render (){
    return (
      <OfferDetailDisplay 
        offer_partner_key={this.state.offer_partner_key} 
        offer_details={this.state.offer_details} 
        activateOffer={this.activateOffer.bind(this)} 
        offer_xid={this.state.offer_xid}
        activating_offer={this.state.activating_offer} />
    )
  }
}

class OfferDetailDisplay extends React.Component {
  render () {

    const offer_details = this.props.offer_details;
    const activateOffer = this.props.activateOffer;
    const activating_offer = this.props.activating_offer;
    const offer_xid = this.props.offer_xid;

    if (offer_details === undefined || offer_details === null || activating_offer){
      return (<LoaderRipple fetching_data={true} />)
    }

    if (offer_xid !== null){
      return (
        <div className="flex-center my-5">
          <div className="m-3 content-section container">
            <div className="text-center">
              <span className="text-size-1 text-dark"> Your offer was activated </span>
            </div>
          </div>
        </div>
      )
    }

    const offer_partner = offer_details.offer_partner;
    if (offer_partner === undefined || offer_partner === null){
      return (
        <div className="flex-center my-5">
          <div className="m-3 content-section container">
            <div className="text-center">
              <span className="text-size-1 text-dark">Invalid or expired offer link. </span>
            </div>
          </div>
        </div>
      )
    }

    const tier_map = {
      'hobby': HOBBY_TIER,
      'startup': STARTUP_TIER, 
      'scale': SCALE_TIER, 
      'enterprise': ENTERPRISE_TIER,
    }
    const offers_map = offer_details.offers;
    const offers = Object.keys(offers_map).map(offer_id => ({ pricing_details: tier_map[offers_map[offer_id].tier], offer_details: offers_map[offer_id]}));

    return (
      <div className="">
        <div className="flex-center">
          <div className="offer-partner-details">
            <div className="">
              <img style={{height: "60px"}} className="hero mx-3" src="/static/images/cursor.svg" alt="Divshow product cursor" />
              <i className="fa fa-plus fa-2x mx-5"></i>
              <img src={offer_partner.logo} alt="divshow offer partner"/>
            </div>
          </div>
        </div>

        <div className="">
          {(offers.length === 0)? (
            <div className="flex-center my-5">
              <div className="m-3 content-section container">
                <div className="text-center">
                  <span className="text-size-1 text-dark">No active offers available. </span>
                </div>
              </div>
            </div>
          ):(
            <OfferPricing offers={offers} activateOffer={activateOffer} />
          )}
        </div>

        <div className="flex-center my-5">
          <Link to="/billing">View full list of DivShow plans!</Link>
        </div>


      </div>

    )
  }
}

export default withRouter(Page);